import { render } from "./AdminUsersComponent.vue?vue&type=template&id=61408919&scoped=true"
import script from "./AdminUsersComponent.vue?vue&type=script&lang=js"
export * from "./AdminUsersComponent.vue?vue&type=script&lang=js"

import "./AdminUsersComponent.vue?vue&type=style&index=0&id=61408919&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61408919"]])

export default __exports__